import Swal from 'sweetalert2';

export const showConfirmation = (message) => {
  return Swal.fire({
    title: "Are you sure?",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: message
  })
}

export const showSuccess = (type, title, message) => {
  return Swal.fire({
    title: title,
    titleText: message,
    type: type
  })
}


// WEBPACK FOOTER //
// ./src/utils/alerts.js